import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('farmDetailsPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_FARM: t('editFarm'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
